export const otherConstants = {
  OTHER_REQUEST: 'USERS_OTHER_REQUEST',
  OTHER_SUCCESS: 'USERS_OTHER_SUCCESS',
  OTHER_FAILURE: 'USERS_OTHER_FAILURE',  
};
